import { render, staticRenderFns } from "./WinView.vue?vue&type=template&id=6050c368&scoped=true"
import script from "./WinView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WinView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WinView.vue?vue&type=style&index=0&id=6050c368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050c368",
  null
  
)

export default component.exports